import { FC } from "react";

import { ProfileContentLoaderStyle } from "./profileContentLoaderStyle";

export const ProfileContentLoader: FC = () => {
  return (
    <ProfileContentLoaderStyle>
      <div className="spinner center">
        <div className="spinner-blade"></div>
        <div className="spinner-blade"></div>
        <div className="spinner-blade"></div>
        <div className="spinner-blade"></div>
        <div className="spinner-blade"></div>
        <div className="spinner-blade"></div>
        <div className="spinner-blade"></div>
        <div className="spinner-blade"></div>
        <div className="spinner-blade"></div>
        <div className="spinner-blade"></div>
        <div className="spinner-blade"></div>
        <div className="spinner-blade"></div>
      </div>
    </ProfileContentLoaderStyle>
  );
};
